<div class="card rounded-2">
	<div class="card-body bg-gray-200  px-4 py-2">
		<ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
			<li class="nav-item">
				<a class="nav-link active" data-bs-toggle="tab" href="#agents_pane_1">Agents</a>
			</li>
		</ul>
		<div class="tab-content" id="myTabContent">
			<div class="tab-pane fade show active" id="agents_pane_1" role="tabpanel">
				<app-cm-users-list></app-cm-users-list>
			</div>
		</div>
	</div>
</div>

<app-add-user-modal (userAdded)="onUserAdded()"></app-add-user-modal>
<app-update-user-detail-modal (userUpdated)="onUserUpdated()"></app-update-user-detail-modal>

<script src="/assets/js/custom/apps/user-management/users/list/export-users.js"></script>
<script src="/assets/js/custom/apps/user-management/users/list/add.js"></script>

<script src="/assets/js/custom/apps/user-management/users/view/view.js"></script>
<script src="/assets/js/custom/apps/user-management/users/view/update-details.js"></script>
<script src="/assets/js/custom/apps/user-management/users/view/add-schedule.js"></script>
<script src="/assets/js/custom/apps/user-management/users/view/add-task.js"></script>
<script src="/assets/js/custom/apps/user-management/users/view/update-email.js"></script>
<script src="/assets/js/custom/apps/user-management/users/view/update-password.js"></script>
<script src="/assets/js/custom/apps/user-management/users/view/update-role.js"></script>
<script src="/assets/js/custom/apps/user-management/users/view/add-auth-app.js"></script>
<script src="/assets/js/custom/apps/user-management/users/view/add-one-time-password.js"></script>